import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import { ViewExportSchema } from "@redotech/redo-model/views/view-exports";
import {
  AdvancedFilterDataSchema,
  VALID_PAGE_SIZES,
} from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const searchViewExports = {
  name: "searchViewExports" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    pageNumber: z.number(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    viewExports: z.array(ViewExportSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export type SearchViewExportsInput = z.infer<typeof searchViewExports.input>;
